import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function ParallaxDivider() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} className="relative h-[60vh] w-full flex items-center justify-center overflow-hidden" data-id="element-132">
      {/* Video Background with Parallax */}
      <motion.div className="absolute inset-0 z-0" style={{
      y,
      scale: 1.2
    }} data-id="element-133">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-134">
          <source src="https://code-11.hr/wp-content/uploads/2026/01/VIDEO-2025-11-01-14-27-11.mp4" type="video/mp4" data-id="element-135" />
        </video>
        <div className="absolute inset-0 bg-charcoal/50" data-id="element-136" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 text-center px-6" data-id="element-137">
        <FadeIn data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-serif text-white italic font-light tracking-wide" data-id="element-139">
            "Where every detail tells your story"
          </h2>
        </FadeIn>
      </div>
    </section>;
}